import store from '../store/store';
import TranslationSettings from '../store/schema/TranslationSettings';
import { mutatorAction } from 'satcheljs';

export default mutatorAction('setTranslationSettings', function setTranslationSettings(
    newSettings: TranslationSettings
) {
    store.settings.translationMode = newSettings.translationMode;
    store.settings.targetLanguage = newSettings.targetLanguage;
    store.settings.excludedLanguages = newSettings.excludedLanguages;
    store.settings.initialized = true;
});
